import { Injectable } from '@angular/core';
import {BaseService} from "@core/service/base.service";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class RandomExpertsService extends BaseService{
  private url = 'api/expert/random';
  constructor(http: HttpClient) {
    super(http);
  }
  getUrl(){
    return this.url;
  }
}
